import { useGetMySummary } from "@/api/user/useGetMySummary";
import { useAuth } from "@/auth/AuthContext";
import { Error } from "@/components/Error";
import { BottomNavigationBar } from "@/components/layout/BottomNavigationBar";
import { OffLogo } from "@/components/shared/OffLogo";
import { Box, Center, Loader, useMantineTheme } from "@mantine/core";
import { Navigate, Outlet } from "react-router-dom";

export function HomePageLayout() {
  const theme = useMantineTheme();
  const footerHeight = 60;
  const {
    data: userSummary,
    isLoading: isUserSummaryLoading,
    isError: isUserSummaryError,
    isSuccess: isUserSummarySuccess,
  } = useGetMySummary();
  const { user } = useAuth();

  if (isUserSummarySuccess && !userSummary?.hasCompletedPersonalityTest) {
    // return <div>you didn't do the personality test</div>;
    return <Navigate to="/personality-test" />;
  }
  if (isUserSummarySuccess && !userSummary?.hasCompletedSignupFlow) {
    // return <div>you didn't do the personality test</div>;
    if (user?.app_metadata.provider === "kakao") {
      return <Navigate to="/signup/kakao" />;
    } else {
      return <Navigate to="/signup" />;
    }
  }

  // Show loading overlay if the query is running OR if we don't have a user
  // object from the auth context yet, as the query depends on it.
  if (isUserSummaryLoading || !user) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  if (isUserSummaryError) {
    return <Error errorMessage="오류가 발생했습니다. 잠시후 다시 시도해주세요." />;
  }

  return (
    <Box
      style={{
        height: "100%",
        backgroundColor: theme.black,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <>
        <Box
          px="xl"
          style={{
            flexGrow: 1,
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <OffLogo />
          <Box style={{ flexGrow: 1 }}>
            <Outlet />
          </Box>
        </Box>

        <Box>
          <BottomNavigationBar footerHeight={footerHeight} />
        </Box>
      </>
    </Box>
  );
}
